export function isBulkSubmitStoreLinkFile(file: Pick<File, 'type' | 'name'>): boolean {
  return file.type === 'text/plain' || file.type === 'text/csv' || /\.(txt|csv)$/i.test(file.name);
}

export function parseBulkSubmitStoreLinkFileContent(fileContent: string): string[] {
  return fileContent
    .replace(/^\uFEFF/, '')
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(line => line.length > 0);
}
